import { Component } from '@angular/core';
import { ModalController } from 'src/app/core/overlay';

@Component({
  selector: 'app-logout-dialog',
  templateUrl: './logout-dialog.page.html',
  styleUrls: ['./logout-dialog.page.scss'],
})
export class LogoutDialogPage {
  constructor(private modalCtrl: ModalController) {}

  async confirm() {
    await this.modalCtrl.dismiss({ confirmed: true });
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }
}
